import { render, staticRenderFns } from "./MbRoulette.vue?vue&type=template&id=af0d811a&scoped=true&"
import script from "./MbRoulette.vue?vue&type=script&lang=js&"
export * from "./MbRoulette.vue?vue&type=script&lang=js&"
import style0 from "./MbRoulette.vue?vue&type=style&index=0&id=af0d811a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0d811a",
  null
  
)

export default component.exports